import { FunctionComponent } from 'react';
import { Controller } from 'react-hook-form';
import { ICommonFormProps } from './DynamicForm.types';

export interface IFormRowProps extends ICommonFormProps {
  Component: FunctionComponent<any>;
}

export const REDUNDUNT_FIELD = 'REDUNDUNT_FIELD';

/**Form row component, handles rendering the component and the error messages */
const FormRow = (props: IFormRowProps) => {
  const { value, ...rest } = props;

  return (
    <Controller
      name={props.keyName}
      control={props.control}
      rules={props.registerOptions}
      defaultValue={value}
      render={({ field }) => {
        return <props.Component {...rest} field={field} defaultValue={value} />;
      }}
    />
  );
};

export default FormRow;
